import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/accommodationExtraServices', request)
}

async function post(request) {
    return await postMethod('/api/accommodationExtraServices', request)
}

async function put(request) {
    return await putMethod('/api/accommodationExtraServices', request)
}

export {get, post, put}
